<div class="input-field">
    @if (label) {
        <label class="input-label">{{ label | translate }}</label>
    }
    <div class="input-wrapper" [class.has-icon]="iconLeft">
        @if (iconLeft) {
            <img [src]="iconLeft" alt="" class="input-icon" />
        }
        <input
            class="input-control"
            [type]="type"
            [placeholder]="placeholder | translate"
            [value]="value"
            [disabled]="disabled"
            (input)="onInput($event)"
            (blur)="onBlur()"
        />
    </div>
</div>
